export default {
    toggleLanguageText: 'Español',
    changePassword: 'Change Password',
    closeSession: 'Close Session',
    exportDialog: {
        title: 'Generating report...',
        message: 'We are generating the CSV. This process may take a few seconds.',
        dontClose: 'Do not close the window'
    },
    exportButton: 'Export',
    exportButtonFull: 'to CSV',
    documents: {
        title: 'Documents',
        filters: {
            initialRegistrationDate: 'Initial Registration Date',
            finalRegistrationDate: 'Final Registration Date',
            initialDocumentDate: 'Initial Document Date',
            finalDocumentDate: 'Final Document Date',
            supplier: 'Supplier',
            documentType: 'Document Type',
            supplierType: 'Supplier Type',
            status: 'Status',
            purchaseOrder: 'Purchase Order',
            organizationCode: 'Organization Code',
            invoiceNo: 'Invoice No.',
            uuid: 'UUID',
            active: 'Active'
        },
        buttons: {
            cancel: 'Cancel',
            accept: 'Accept',
            clear: 'Clear',
            go: 'Go',
            goToPage: 'Go to page'
        },
        headers: {
            invoiceNo: 'Invoice No.',
            uuid: 'UUID',
            registrationDate: 'Registration Date',
            documentDate: 'Document Date',
            organizationCode: 'Organization Code',
            supplierNo: 'Supplier No.',
            supplier: 'Supplier',
            status: 'Status',
            details: 'Details',
            sapResponse: 'SAP Response',
            sapResponseDetails: 'SAP Response Details',
            documentNo: 'Document No.',
            accountingDocumentNo: 'Accounting Document No.',
            phase: 'Phase',
            documentType: 'Document Type',
            supplierType: 'Supplier Type',
            relatedDoc: 'Related Doc.',
            comments: 'Comments',
            active: 'Active',
            uploadMethod: 'Upload Method',
            company: 'Company'
        },
        pagination: {
            itemsPerPage: 'Items per page:',
            page: 'Page:',
            pageShort: 'Page:',
            of: 'of'
        },
        messages: {
            noDocument: 'No document',
            noComments: 'No comments',
            yes: 'Yes',
            no: 'No',
            noRecords: 'No records found for your search parameters. Please try another search or create a new entry.',
            formUpdateSuccess: 'Record updated successfully.',
            formUpdateError: 'Error updating record.',
            formCancelSuccess: 'Record cancelled successfully.',
            formCancelError: 'Error cancelling record.',
            formDownloadError: 'Error downloading files.',
            formLoadError: 'Error loading record.'
        },
        documentTypes: {
            invoice: 'Invoice',
            paymentComplement: 'Payment Complement'
        }
    },
    errors: {
        errorGetList: 'There was a problem getting the list',
        errorGetSuppliers: 'There was a problem getting the suppliers list',
        errorGetStatuses: 'There was a problem getting the statuses list',
        errorGetSupplierTypes: 'There was a problem getting the supplier types list',
        errorGetUuids: 'There was a problem getting the UUIDs list',
        invalidPageNumber: 'The entered page number does not exist',
        exportError: 'Error exporting CSV',
        exportCsvProcessing: 'There was a problem processing the CSV. Please try again.'
    }
}

